import React from 'react';

const DetailRow = ({label, value, valueClassName = 'text-deepBlue'}) => (
  <div className="flex items-center justify-between py-3 border-t border-[#F6F7F9] first:border-t-0">
    <p className="text-small text-[#858DAA] capitalize">
      {label.replaceAll('_', ' ')}
    </p>
    <p className={`text-tiny font-medium ${valueClassName}`}>{value || '-'}</p>
  </div>
);

export {DetailRow};
